@if (!inline) {
<div
  id="overlay"
  [style.top.px]="top"
  [style.height.px]="relativeWidthAndHeight ? undefined : loaderHeight"
  [style.width]="loaderWidth"
  class="overlay fill"
  [class.visible]="showLoader"
  [ngClass]="{ 'relative-width-height': relativeWidthAndHeight }"
>
  <div id="spinner-container" style="margin-top: -{{ top }}px;">
    <div
      class="spinner"
      [class.spinner-enter]="spinnerAnimClass === 'spinner-enter'"
      [class.spinner-leave]="spinnerAnimClass === 'spinner-leave'"
    >
      <span class="pill-1"></span>
      <span class="pill-2"></span>
      <span class="pill-3"></span>
      <span class="pill-4"></span>
      <span class="pill-5"></span>
      <span class="pill-6"></span>
      <span class="pill-7"></span>
      <span class="pill-8"></span>
      <span class="pill-9"></span>
    </div>
    <div
      id="helper-text"
      [class.loading-text-enter]="spinnerAnimClass === 'spinner-enter'"
      [class.loading-text-leave]="spinnerAnimClass === 'spinner-leave'"
    >
      {{ helperText }}
    </div>
  </div>
</div>
} @else {
<div id="inline" [style.width]="loaderWidth" [class.visible]="showLoader">
  <div
    class="spinner"
    [class.spinner-enter]="spinnerAnimClass === 'spinner-enter'"
    [class.spinner-leave]="spinnerAnimClass === 'spinner-leave'"
  >
    <span class="pill-1"></span>
    <span class="pill-2"></span>
    <span class="pill-3"></span>
    <span class="pill-4"></span>
    <span class="pill-5"></span>
    <span class="pill-6"></span>
    <span class="pill-7"></span>
    <span class="pill-8"></span>
    <span class="pill-9"></span>
  </div>
</div>
}
